module.exports = ":host() {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n  :host() .alg-face-item {\n    display: inline-block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/molecules/alg-face-group/alg-face-group.component.scss
// module id = ./src/app/components/molecules/alg-face-group/alg-face-group.component.scss
// module chunks = main